import React, { useState, useEffect } from 'react';
import { useAuth } from '../AuthContext';
import { storageAPI, filesAPI } from '../api';

function Dashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);
  const [recentFiles, setRecentFiles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadDashboardData();
  }, []);

  const loadDashboardData = async () => {
    try {
      const [storageRes, filesRes] = await Promise.all([
        storageAPI.getStats(),
        filesAPI.getMyFiles(),
      ]);
      
      setStats(storageRes.data.stats);
      setRecentFiles(filesRes.data.files.slice(0, 5));
    } catch (error) {
      console.error('Error loading dashboard:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatBytes = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  if (loading) {
    return (
      <div className="container">
        <div className="loading">
          <div className="spinner"></div>
          <p>Loading dashboard...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <h1 className="mb-3">Dashboard</h1>
      
      <div className="card mb-3">
        <h2>Welcome, {user?.username}!</h2>
        <p className="text-muted">Email: {user?.email}</p>
      </div>

      {stats && (
        <div className="card mb-3">
          <h3 className="mb-2">Storage Usage</h3>
          <p className="mb-2">
            <strong>Tier:</strong> {stats.tier_name}
          </p>
          <div style={{ marginBottom: '10px' }}>
            <div
              style={{
                width: '100%',
                height: '20px',
                background: '#dfe7fd',
                overflow: 'hidden',
                border: '1px solid #c5cde8',
                borderRadius: '4px',
              }}
            >
              <div
                style={{
                  width: `${Math.min(stats.percentage, 100)}%`,
                  height: '100%',
                  background:
                    stats.percentage > 90
                      ? '#c96a7a'
                      : stats.percentage > 70
                      ? '#c9a34a'
                      : '#6da88d',
                  transition: 'width 0.3s ease',
                }}
              />
            </div>
          </div>
          <p className="text-small text-muted">
            {formatBytes(stats.used)} of {formatBytes(stats.quota)} used (
            {stats.percentage.toFixed(1)}%)
          </p>
        </div>
      )}

      <div className="card">
        <div className="d-flex justify-between align-center mb-2">
          <h3>Recent Files</h3>
          <a href="/my-files" className="btn btn-primary">
            View All
          </a>
        </div>
        
        {recentFiles.length === 0 ? (
          <p className="text-muted">No files uploaded yet.</p>
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>Filename</th>
                <th>Size</th>
                <th>Visibility</th>
                <th>Uploaded</th>
              </tr>
            </thead>
            <tbody>
              {recentFiles.map((file) => (
                <tr key={file.file_id}>
                  <td>{file.filename}</td>
                  <td>{formatBytes(file.size)}</td>
                  <td>
                    <span
                      className={`badge ${
                        file.visibility === 'public'
                          ? 'badge-success'
                          : 'badge-warning'
                      }`}
                    >
                      {file.visibility}
                    </span>
                  </td>
                  <td>{formatDate(file.uploaded_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default Dashboard;
